import {connect} from "react-redux";
import {DispatchProps, InnerProps, PaymentInfo, StateProps} from "../components/PaymentInfo";
import {RootState, ThunkDispatch} from "../types";
import {doCheckCustomer, doGetCustomer, doGetProductExclusive, doSubscribeToPlans} from "../actions/thunks/customer";
import {v4} from "uuid";
import {IVA} from "../utils/constants";
import {navigate, Routes} from "../utils/router";
import {confirmBox} from "@kopjra/uikit";
import {I18n} from "react-redux-i18n";
import {removeFromCart} from "../actions/products";

function mapStateToProps({i18n, customer, product}: RootState): StateProps {
    return {
        locale: i18n.locale,
        customer: customer.customer,
        cart: product.cart,
        promotion: product.promotion,
        cartUUID: product.cartUUID || v4(),
        tax: (product.taxRates?.percentage || IVA * 100) / 100,
        exclusives: product.exclusives,
        subscribing: customer.subscribing,
    };
}

function mapDispatchToProps(dispatch: ThunkDispatch): DispatchProps {
    return {
        onCheckCustomer: () => dispatch(doCheckCustomer()),
        onGetCustomer: () => dispatch(doGetCustomer()),
        onSubscribeToPlans: (customer, cart, cartUUID, stripe, promotion) => dispatch(doSubscribeToPlans(customer, cart, cartUUID, stripe, promotion)),
        onGetProductExclusive: () => dispatch(doGetProductExclusive()),
        onEditCartElement: (solution, id) => {navigate(Routes.SOLUTION_DETAIL(solution, id));},
        onRemoveFromCart: async (id) => { await confirmBox({
            message: I18n.t("cart.deleteConfirm"),
            yesText: I18n.t("generic.yes"),
            noText:  I18n.t("generic.no"),
            yesFunc: () => { dispatch(removeFromCart(id)); },
        })},
    };
}

export default connect<StateProps, DispatchProps, InnerProps, RootState>(mapStateToProps, mapDispatchToProps)(PaymentInfo);

// TODO: TEST: billing Info and payment Info and then subscribe mother fukka
